var map = {
	"./1_hello.mp3": "3f10",
	"./2_bye_bye.mp3": "ea8b",
	"./4_Lisa.mp3": "2d76",
	"./57_legs.mp3": "54b9",
	"./58_hands.mp3": "238a",
	"./59_head.mp3": "9090",
	"./61_stretch.mp3": "1690",
	"./62_shake.mp3": "73cb",
	"./63_pat.mp3": "69eb",
	"./6_bear.mp3": "ca85",
	"./7_mole.mp3": "d2e4",
	"./M_Brilliant.mp3": "05fe",
	"./M_Excellent.mp3": "4243",
	"./M_Fantastic.mp3": "e012",
	"./M_Great.mp3": "5a8b",
	"./M_Perfect.mp3": "5194",
	"./M_Think again.mp3": "b4fb",
	"./M_Try again.mp3": "ddef",
	"./M_Very good.mp3": "d8e3",
	"./M_Well done.mp3": "3dd2",
	"./M_Work harder.mp3": "b90b",
	"./click.mp3": "87ad",
	"./false.mp3": "ddcc",
	"./true.mp3": "5ede"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6f0";